import { gsap, ScrollTrigger, ScrollToPlugin } from 'gsap/all';
import { CountUp } from 'countup.js';
import btnAnimate from '../text-animations/btn';
import { SplitText } from '../vendor/gsap/SplitText';
import { ScrollSmoother } from '../vendor/gsap/ScrollSmoother';
import smoov from '../util/smooth-scroll';
import '../util/form-label';

gsap.registerPlugin(ScrollTrigger, SplitText, ScrollSmoother, ScrollToPlugin);
smoov();
// Animated number countup function for the stats block
function runNum(elem) {
    if ($(elem).hasClass('activated')) {
        return false;
    }
    const dataNum = $(elem).attr('data-num');
    const thisId = $(elem).attr('id');
    const statNum = new CountUp(`${thisId}`, dataNum, {
        decimal: ',',
    });

    if (!statNum.error) {
        $(elem).addClass('activated');
        statNum.start();
    } else {
        console.error(statNum.error);
    }
    return false;
}

// Create media query
const mm = gsap.matchMedia();

function mobileParallax() {
    gsap.to('.masthead-parallax-image .img-parent', {
        yPercent: -10,
        ease: 'none',
        scrollTrigger: {
            trigger: '.masthead-parallax-image',
            start: 'top bottom', // the default values
            end: 'bottom top',
            scrub: true,
        },
    });
}

function lgParallax() {
    gsap.to('.masthead-parallax-image .img-parent', {
        yPercent: -10,
        ease: 'none',
        scrollTrigger: {
            trigger: '.masthead-parallax-image',
            start: 'top bottom', // the default values
            end: 'bottom top',
            scrub: true,
        },
    });
}

function parallaxDecide() {
    // When these media queries match, the associated function will run
    mm.add('(min-width: 992px)', () => {
        lgParallax();
    });

    mm.add('(max-width: 992px)', () => {
        mobileParallax();

        return () => {
            // custom cleanup code here (runs when it STOPS matching)
            ScrollTrigger.refresh();
            lgParallax();
        };
    });
}

if ($('body').hasClass('insights-detail')) {
    parallaxDecide();
    // Quoteblock turbo lines (above and below quote)
    const quoteBlocks = gsap.utils.toArray('.quote-trigger');

    quoteBlocks.forEach((item) => {
        const line = $(item).find('.turbo-line-stretch');
        gsap.to(line, {
            scaleX: 1,
            scrollTrigger: {
                trigger: item,
                start: 'top 80%',
                scrub: true,
                end: 'top 10%',
            },
        });
    });

    const blocks = document.querySelectorAll('.stats-item');

    blocks.forEach((block) => {
        const num = $(block).find('.anim-number');
        const blockTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: '.animated-stats-block',
                start: 'top 85%',
                end: 'bottom top',
                toggleActions: 'play none none none',
                onEnter: () => { runNum(num); },
            },
        })
            // Animate the header items
            .from(block.querySelectorAll('.stat-hdr'), {
                duration: 1,
                opacity: 0,
                stagger: 0.25,
            });

        // Animate the content items
        const items = block.querySelectorAll('.stat-body');
        blockTimeline.from(items, {
            duration: 1,
            x: 40,
            opacity: 0,
            stagger: 0.25,
        }, 0);

        // Animate the ps in the items
        items.forEach((item, i) => {
            blockTimeline.from(item.querySelectorAll('p'), {
                duration: 1,
                opacity: 0,
                stagger: 0.25,
            }, i * 0.25);
        });
    });
}

// For after dom loaded
function checkForBtn() {
    $('.js-btn-split').each((e, index) => {
        btnAnimate(index);
    });

    $('.link:not(.dropdown-item):not(.footer-link):not(.privacy-policy)').each((e, index) => {
        btnAnimate(index);
    });
}

if ($('body').hasClass('news-index')) {
    document.body.addEventListener('htmx:afterSettle', (evt) => {
        // evt.preventDefault();
        ScrollTrigger.refresh();
        checkForBtn();
    });
}

if ($('.fixed-masthead').length > 0) {
    ScrollTrigger.create({
        trigger: '.fixed-masthead',
        start: 'top bottom',
        end: 'bottom top',
        EnterBack: () => gsap.to('.masthead-background-image', { visibility: 'visible' }),
        onLeave: () => gsap.to('.masthead-background-image', { visibility: 'hidden' }),
        onLeaveBack: () => gsap.to('.masthead-background-image', { visibility: 'visible' }),
        onEnterBack: () => gsap.to('.masthead-background-image', { visibility: 'visible' }),
    });
}

// Long scroll block
const blockTrigger = document.querySelector('.long-scroll-content');
const contentPin = document.querySelector('.long-scroll-content .copy-column');

function initBIG() {
    ScrollTrigger.create({
        trigger: blockTrigger,
        start: 'top top',
        pin: contentPin,
        pinSpacing: false,
        anticipatePin: 1,
        end: () => `+=${blockTrigger.offsetHeight - contentPin.offsetHeight}px`,
        invalidateOnRefresh: true,
        clearProps: true,
    });
}

function scrollDecide() {
    // When these media queries match, the associated function will run
    mm.add('(min-width: 992px)', () => {
        initBIG();
    });

    mm.add('(max-width: 992px)', () => {
        return () => {
            // custom cleanup code here (runs when it STOPS matching)
            ScrollTrigger.refresh();
        };
    });
}

// later, if we need to revert all the animations/ScrollTriggers...
if ($('.long-scroll-content').length > 0) {
    scrollDecide();
}

ScrollTrigger.defaults({
    anticipatePin: 1,
});
